module.exports = __webpack_public_path__ + "static/media/5.b87f5095.jpg";